import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { RequestCacheInterceptor } from './app/interceptors/request-cache.interceptor';

const optimizedAppConfig = {
  ...appConfig,
  providers: [
    ...(appConfig.providers || []),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: RequestCacheInterceptor,
      multi: true,
    },
  ],
};

bootstrapApplication(AppComponent, optimizedAppConfig).catch((err) =>
  console.error(err)
);
